import { render } from "./ShowFull.vue?vue&type=template&id=7b68e1a6"
import script from "./ShowFull.vue?vue&type=script&lang=ts"
export * from "./ShowFull.vue?vue&type=script&lang=ts"

import "./ShowFull.vue?vue&type=style&index=0&id=7b68e1a6&lang=postcss"
script.render = render

export default script